import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer,
  AfterViewInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Directive({
  selector: '[OnlyNumber]'
})
export class OnlyNumber implements AfterViewInit {
  constructor(private el: ElementRef, public renderer: Renderer) { }

  @Input() OnlyNumber: boolean;
  @Input() defaultZero: boolean;
  @Input() AllowNegative: boolean;
  @Input() RemoveLeadingZero: boolean;
  public regex = new RegExp(
    /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/,
    'g'
  );

  public numberRegex = new RegExp(/[0-9\-]/, 'g');

  public browsers: string[] = [
    'chrome',
    'safari',
    'firefox',
    'ie',
    'internet explorer',
    'edge'
  ];

  ngAfterViewInit() {
    if (this.RemoveLeadingZero) {
      this.el.nativeElement.value = this.el.nativeElement.value.replace(/^0+/, '');
    }
  }


  // public jpFull = new RegExp(/[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\u4E00-\u9FAF]/, 'g');
  // public jpHalf = new RegExp(/[\uFF00-\uFFEF]/, 'g');
  // public symbols = new RegExp(/[\u2605-\u2606]|[\u2190-\u2195]|\u203B/, 'g');
  // public ENG = new RegExp(/[\u0000-\u007F]/, 'g');

  @HostListener('keydown', ['$event'])
  onKeyDown(event) {
    const e = <KeyboardEvent>event;
    const matchDash = event.target.value.match(/[-]/, 'g');

    // console.log('​onKeyDown -> ', e.keyCode);

    // console.log('matchDash ', matchDash);
    if (this.OnlyNumber) {
      if (
        [46, 8, 9, 27, 13, 92, 110, 190].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode == 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode == 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return;
      }

      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
        (e.keyCode < 96 || (e.keyCode > 105 && e.keyCode)) // 109 key minus
      ) {
        if (this.AllowNegative) {
          if (this.browserDetect().browser !== this.browsers[2]) {
            // isFirefox
            if (e.keyCode === 109 || e.keyCode === 189) {
              if (matchDash) {
                e.preventDefault();
              }
              return;
            } else {
              e.preventDefault();
            }
          } else {
            if (e.keyCode === 109 || e.keyCode === 173) {
              if (matchDash) {
                e.preventDefault();
              }
              return;
            } else {
              e.preventDefault();
            }
          }
        } else {
          e.preventDefault();
        }
      }
    }
  }

  @HostListener('focus', ['$event'])
  onFocus(event) {
    const e = <KeyboardEvent>event;
    if (this.OnlyNumber) {
      this.el.nativeElement.select();
      this.renderer.setElementStyle(
        this.el.nativeElement,
        'backgroundColor',
        '#76FF03'
      );
    } else {
      this.renderer.setElementStyle(
        this.el.nativeElement,
        'backgroundColor',
        ''
      );
    }
  }

  @HostListener('focusout', ['$event'])
  onFocusout(event) {
    const e = <KeyboardEvent>event;
    if (this.OnlyNumber) {
      if (event.target.value.match(this.regex)) {
        if (this.defaultZero) {
          this.el.nativeElement.value = 0;
        } else {
          this.el.nativeElement.value = '';
        }
      } else if (this.RemoveLeadingZero) {
        this.el.nativeElement.value = event.target.value.replace(/^0+/, '');
      }
      this.renderer.setElementStyle(
        this.el.nativeElement,
        'backgroundColor',
        ''
      );
    }
  }

  browserDetect(): { browser: string } {
    const userAgent = window.navigator.userAgent;
    const language = window.navigator.language;
    // console.log('​language', window.navigator);

    const Detecting = this.browsers.filter((val, index) =>
      userAgent
        .toLocaleUpperCase()
        .includes(this.browsers[index].toLocaleUpperCase())
    );

    return { browser: Detecting[0].toString() };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/onlynumber.directive.ts